<snelstart-ui-dialog-definition id="tm" title="Specificatie van {{this.title}}" size="xl" [(visible)]="dialogVisible">
  <snelstart-ui-dialog-body>
    <div class="row flex-nowrap">
      <div class="col col-1 bold">
        Omschrijving
      </div>
      <div class="col-2"></div>
      <div class="col-3 bold">
        Huidige periode
      </div>
      @if (this.period2Visible) {
        <div class="col-4 bold">
          Vorige periode
        </div>
      }
      <div class="col-auto" style="width: 48px;"></div>
    </div>
    <div class="pt-1"></div>
    <form [formGroup]="inputFg">
      <ng-container formArrayName="trialBalanceItems">
        @for (item of trialBalanceItems.controls; track item; let i = $index) {
          <ng-container [formGroupName]="i">
            <div class="row flex-nowrap">
              <div class="col col-1">
                <snelstart-ui-text-form-control formControlName="accountDescription"
                                                id="accountDescription"
                                                [required]=true
                                                class="custom-input-400"
                                                [disabledControl]="item.get('autogenerated')?.value === true"
                >
                </snelstart-ui-text-form-control>
              </div>
              <div class="col-2"></div>
              <ng-container formGroupName="periodValues">
                <div class="col-3">
                  <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                                    class="custom-input-150"
                                                    align="right"
                                                    prefix="€"
                                                    [showAllDecimals]="false"
                                                    [disabledControl]="item.get('autogenerated')?.value === true"
                                                    (change)="this.getTotalen()"
                  >
                  </snelstart-ui-number-form-control>
                </div>
                @if (this.period2Visible) {
                  <div class="col-4">
                    <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                                      class="custom-input-150"
                                                      align="right"
                                                      prefix="€"
                                                      [showAllDecimals]="false"
                                                      [disabledControl]="item.get('autogenerated')?.value === true"
                                                      (change)="this.getTotalen()"
                    >
                    </snelstart-ui-number-form-control>
                  </div>
                }
              </ng-container>
              <div class="col-auto">
                <snelstart-ui-button
                  id="buttonDelete"
                  type="secondary"
                  size="medium"
                  icon="trash"
                  iconType="light"
                  [disabled]="item.get('autogenerated')?.value === true"
                  (click)="verwijderRij(i)"
                >
                </snelstart-ui-button>
              </div>
            </div>
          </ng-container>
        }
      </ng-container>
      <div class="row flex-nowrap">
        <div class="col col-1 bold">
          <div>
            <div>
              <div>Totaal</div>
              <snelstart-ui-button id="add" class="snelstart-ui-button" type="link" icon="plus"
                                   (click)="addRij()">Item toevoegen
              </snelstart-ui-button>
            </div>
          </div>
        </div>
        <div class="col-2"></div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        @if (this.period2Visible) {
          <div class="col-4">
            <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                              class="custom-input-150 custom-readonly"
                                              align="right"
                                              prefix="€"
                                              [showAllDecimals]="false"
                                              [disabledControl]="true"
            >
            </snelstart-ui-number-form-control>
          </div>
        }

        <div class="col-auto" style="width: 48px;"></div>
      </div>

    </form>
  </snelstart-ui-dialog-body>
  <snelstart-ui-dialog-buttons class="d-flex">
    <snelstart-ui-button id="cancel" class="me-1" type="secondary" btn-x (click)="cancel()">
      Annuleren
    </snelstart-ui-button>
    <snelstart-ui-button id="save" type="primary" icon="check" (click)="submit()">
      Akkoord
    </snelstart-ui-button>
  </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>

